import { useState, useEffect } from "react";

function NotificationBar({ notifications, primaryColor }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [selected, setSelected] = useState(null);
  const [fade, setFade] = useState(true);

  // Auto-rotate through notifications every 4 seconds
  useEffect(() => {
    if (notifications.length <= 1) return;

    const interval = setInterval(() => {
      setFade(false); // start fade-out
      setTimeout(() => {
        setActiveIndex((i) => (i + 1) % notifications.length);
        setFade(true); // fade back in with new content
      }, 250);
    }, 4000);

    return () => clearInterval(interval);
  }, [notifications.length]);

  if (!notifications || notifications.length === 0) return null;

  const current = notifications[activeIndex];

  return (
    <>
      <div className="bg-warning-subtle border-bottom">
        <div className="container py-2 d-flex align-items-center gap-2 flex-wrap">
          <span className="badge bg-warning text-dark flex-shrink-0">
            <i className="bi bi-megaphone-fill me-1"></i> Notice
          </span>

          <div
            role="button"
            onClick={() => setSelected(current)}
            className="fw-medium text-decoration-none text-dark"
            style={{
              opacity: fade ? 1 : 0,
              transition: "opacity 0.25s ease",
              cursor: "pointer",
            }}
          >
            {current.title}
          </div>

          {notifications.length > 1 && (
            <div className="d-flex gap-1 ms-auto flex-shrink-0">
              {notifications.map((_, i) => (
                <span
                  key={i}
                  onClick={() => {
                    setFade(false);
                    setTimeout(() => {
                      setActiveIndex(i);
                      setFade(true);
                    }, 200);
                  }}
                  role="button"
                  style={{
                    width: "6px",
                    height: "6px",
                    borderRadius: "50%",
                    backgroundColor:
                      i === activeIndex ? primaryColor || "#0d6efd" : "#d0d0d0",
                    cursor: "pointer",
                    transition: "background-color 0.2s",
                  }}
                ></span>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Detail modal */}
      {selected && (
        <>
          <div className="modal show d-block" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    {selected.is_pinned && (
                      <i className="bi bi-pin-angle-fill text-warning me-2"></i>
                    )}
                    {selected.title}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setSelected(null)}
                  ></button>
                </div>
                <div className="modal-body">
                  {selected.body && (
                    <p style={{ whiteSpace: "pre-line" }}>{selected.body}</p>
                  )}
                  <p className="text-muted small mb-0">
                    <i className="bi bi-calendar3 me-1"></i>
                    {new Date(selected.publish_date).toLocaleDateString(
                      "en-IN",
                      {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      },
                    )}
                  </p>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => setSelected(null)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop show"></div>
        </>
      )}
    </>
  );
}

export default NotificationBar;
